export default "__VITE_ASSET__BnxJu$EC__"